<template>
    <div>

        <ComunDialogComp v-model="compEstado2" maxWidth="1000" @close-modal="$emit('close')">
            <template v-slot:title>
                Calendario de actividades de
                <v-chip dark class="ml-2" :color="compParametro2.item.color_nivel">
                    <span class="font-weight-black">Nivel: {{ compParametro2.item.desc_nivel }} |
                        {{ compParametro2.item.desc_grado }} | Sección: {{ compParametro2.item.nombre_seccion }}</span>
                </v-chip>
            </template>
            <template v-slot:body>
                <v-row dense>
                    <v-col cols="12" class="d-flex justify-center">
                        <v-btn fab dark x-small class="mr-2 btn_block_style2" @click="prev">
                            <v-icon>fa-chevron-left</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ title }}</v-toolbar-title>
                        <v-btn fab dark x-small class="ml-2 btn_block_style2" @click="next">
                            <v-icon>fa-chevron-right</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-sheet height="700">
                            <v-calendar style="border: 1px solid #e7e7e7" ref="calendar" v-model="focus" color="primary"
                                :events="combinedEvents" :event-color="getEventColor" :now="today" :type="type"
                                @click:date="crearActividad" @click:event="showEvent" @change="updateRange"
                                :short-weekdays="false" :weekdays="diaHabil" :short-months="false"
                                :short-intervals="false" :first-interval="intervals.first"
                                :interval-minutes="intervals.minutes" :interval-count="intervals.count"
                                :interval-height="intervals.height"></v-calendar>
                        </v-sheet>
                    </v-col>

                </v-row>

            </template>

        </ComunDialogComp>





        <!-- modal ver detalles de la actividad del calendario -->
        <ComunDialogComp v-model="selectedOpen" :activator="selectedElement" maxWidth="500"
            :title="'Detalle de la actividad : ' + selectedEvent.desc_tipo_actividad"
            @close-modal="selectedOpen = false">
            <template v-slot:body>
                <template v-if="selectedEvent.id_periodo">
                    <v-row>
                        <v-col cols="12" class="d-flex justify-center">
                            <v-chip label color="primary" class="mx-2" dark>
                                Nivel: {{ selectedEvent.desc_nivel }}
                            </v-chip>
                            <v-chip label color="primary" class="mx-2" dark>
                                Grado: {{ selectedEvent.desc_grado }}
                            </v-chip>
                            <v-chip label color="primary" class="mx-2" dark>
                                Sección: {{ selectedEvent.nombre_seccion }}
                            </v-chip>
                        </v-col>
                        <v-col cols="12">
                            <v-card outlined>
                                <v-card-title :style="{ background: selectedEvent.color_curso }"
                                    class="d-flex justify-center">
                                    <v-chip color="white font-weight-black" label>
                                        <v-icon left small>{{ selectedEvent.icono_curso }}</v-icon>
                                        {{ selectedEvent.desc_curso }}</v-chip>
                                </v-card-title>
                                <v-card-text>
                                    <v-col class="pt-2">
                                        <p class="black--text"><span class="font-weight-black">Unidad:</span>
                                            {{ selectedEvent.nombre_tema }}</p>
                                        <p class="black--text"><span class="font-weight-black">Tema:</span>
                                            {{ selectedEvent.nombre_clase }}</p>
                                        <p class="black--text"><span class="font-weight-black">Fecha Entrega:</span>
                                            {{ selectedEvent.fecha_actividad | filtroFecha }}</p>
                                        <p class="black--text"><span class="font-weight-black">Hora Entrega:</span>
                                            {{ selectedEvent.hora_fin_actividad | filtroFormatoHora }} </p>
                                    </v-col>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                </template>

                <template v-else>
                    <v-card color="grey lighten-4" min-width="150px" heigth="200px" flat>
                        <v-toolbar :color="selectedEvent.color" dark>
                            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <v-card-text>
                            <v-form>
                                {{ selectedEvent.name }} - {{ selectedEvent.details }}
                            </v-form>
                        </v-card-text>

                    </v-card>
                </template>

            </template>

        </ComunDialogComp>






        <!-- Calendario de activadades de la seccion -->
        <component :is="tipoComponente2" :modalCrearActividad="estadoModalCrear" @close2="estadoModalCrear = false"
            @calendario_actualizar="get_events()" :datosSeccion="compParametro2.item" :fechaActual="fechaSeleccionada"
            :eventoAct="compParametro2.evento" :addWizard="addWizard"></component>


    </div>
</template>

<script>
import axios from "@/helpers/axios";
import moment from 'moment'
import { mapMutations, mapGetters, mapState } from 'vuex';

import ModalCrearActividades from './CrearActividad.vue'

import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';

export default {
    name: 'modalActividadSeccion',

    components: {
        ModalCrearActividades,
        ComunDialogComp
    },

    props: ['compEstado2', 'compParametro2'],
    //props:['modalActividad', 'datosClase', 'eventoActividad'],

    data: () => ({
        datoLogin: sessionStorage,
        today: moment().format('YYYY-MM-DD'),
        focus: '',
        type: 'month',
        // orden de semana de lunes a domingo (dias del calendario)
        /* orden del calendario en vista de semana y dia
        hora de inicio, division de renglones, bloque de horas, medida de renglones*/
        intervals: {
            first: 11,
            minutes: 30,
            count: 30,
            height: 40,
        },
        start: 0,
        end: 0,
        events: [],
        diaHabil: [1, 2, 3, 4, 5, 6],
        events2: [],
        name: null,
        details: null,
        color: null,

        // ventana de detalles del item
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,



        // consulta principal

        // variable iniciales
        actividad: [],
        /////////////////////


        // componente calendario de actividades por seccion
        tipoComponente2: '',
        estadoModalCrear: true,
        fechaSeleccionada: '',
        addWizard: false,
        ////////////////////////////
    }),


    computed: {
        ...mapGetters('progDocente', ['getConfiguracion']),
        ...mapState({
            idsDiasSeleccionados: "idsDiasSeleccionados",
            fechasFeriado: "fechasFeriado",
        }),

        combinedEvents() {
            // Combinar los dos conjuntos de eventos en uno solo para renderizados
            return [...this.events, ...this.events2];
        },

        title() {
            const { start, end } = this
            if (!start || !end) {
                return ''
            }

            const startMonth = this.monthFormatter(start)
            // const endMonth = this.monthFormatter(end)
            // const suffixMonth = startMonth === endMonth ? '' : endMonth

            const startYear = start.year
            // const endYear = end.year
            // const suffixYear = startYear === endYear ? '' : endYear

            const startDay = start.day
            // const endDay = end.day

            switch (this.type) {
                case 'month':
                    return `${startMonth} ${startYear}`
                case 'week':
                    break
                /* case '4day':
                    return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}` */

                case 'day':
                    return `${startMonth} ${startDay} de ${startYear}`
            }
            return ''
        },


        monthFormatter() {
            return this.$refs.calendar.getFormatter({
                timeZone: 'UTC', month: 'long',
            })
        },
    },




    created() {
        this.get_events()
    },


    methods: {
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),


        //  ------- Cargar todas las actividadesde de esta seccion   --------
        async get_events() {
           
            try {
               
                const events = []

                let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/seccion/${this.compParametro2.item.id_seccion}/usuario/${this.datoLogin.id}`
              
                let response = await axios.get(`/academico/actividades/getQuery${params}`)
             
                let data = response.data
            
                this.actividad = data.ActividadesSeccion

                // 1.- Se dispara el action , me traigo el estado y lo igualo a this.diasHabil
                this.$store.dispatch('getDiasHabiles').then(() => {
                    this.diaHabil = this.idsDiasSeleccionados.idsDiasSeleccionados[0].dias_seleccionados;
                })
           
                // 2.- Aca me traigo los dias feriados
                this.$store.dispatch("getFechasFeriado").then(() => {
                    const eventos = this.fechasFeriado.fechasFeriado.map((evento) => ({
                        name: evento.name,
                        start: evento.start,
                        end: evento.end,
                        color: evento.color,
                        details: evento.details,
                        id: evento.id,
                    }));

                    this.events2 = eventos;
                })

              

                if (this.actividad.length != 0) {
                    this.actividad.forEach(doc => {

                        let eventoData = doc
                        eventoData.id = doc.id

                        eventoData.name = `${doc.desc_tipo_actividad}`
                        eventoData.color = doc.color_curso
                        eventoData.details = `<span class="font-weight-black ">${doc.desc_nivel} </span>
                                            <span class="font-weight-black">${doc.desc_grado}  </span> `

                        eventoData.start = `${doc.fecha_actividad} ${doc.hora_fin_actividad}`
                        eventoData.end = `${doc.fecha_actividad} ${doc.hora_fin_actividad}`

                        // //1.- Se dispara el action , me traigo el estado y lo igualo a this.diasHabil
                        // this.$store.dispatch('getDiasHabiles').then(() => {
                        //     this.diaHabil = this.idsDiasSeleccionados.idsDiasSeleccionados[0].dias_seleccionados;
                        // })

                        // //2.- Aca me traigo los dias feriados
                        // this.$store.dispatch("getFechasFeriado").then(() => {
                        //     const eventos = this.fechasFeriado.fechasFeriado.map((evento) => ({
                        //         name: evento.name,
                        //         start: evento.start,
                        //         end: evento.end,
                        //         color: evento.color,
                        //         details: evento.details,
                        //         id: evento.id,
                        //     }));

                        //     this.events2 = eventos;
                        // })

                        events.push(eventoData)
                    })
                    this.events = events
                } else {
                    
                    //1.- Se dispara el action , me traigo el estado y lo igualo a this.diasHabil
                    this.$store.dispatch('getDiasHabiles').then(() => {
                        this.diaHabil = this.idsDiasSeleccionados.idsDiasSeleccionados[0].dias_seleccionados;
                    })

                    //2.- Aca me traigo los dias feriados
                    this.$store.dispatch("getFechasFeriado").then(() => {
                        const eventos = this.fechasFeriado.fechasFeriado.map((evento) => ({
                            name: evento.name,
                            start: evento.start,
                            end: evento.end,
                            color: evento.color,
                            details: evento.details,
                            id: evento.id,
                        }));

                        this.events2 = eventos;

                        this.events = events
                    })
                }
            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
            }

        },


        // click en la fecha seleccionada para agregar una actividad
        crearActividad({ date }) {
            if (date < new Date().toISOString().substr(0, 10)) {
                this.setEnviarMens({ tipo: "W", mensaje: 'No puede crear una actividad a una fecha pasada', tiempo: null })
            }

            else {
                this.tipoComponente2 = 'ModalCrearActividades'
                this.estadoModalCrear = true
                this.fechaSeleccionada = date
            }
        },
        /////////////////////////////////






        /// FUNCIONES DEL CALENDARIO ///////////////////
        viewDay({ date }) {
            this.focus = date
            this.type = 'day'
        },

        getEventColor(event) {
            return event.color
        },


        prev() {
            this.$refs.calendar.prev()
        },


        next() {
            this.$refs.calendar.next()
        },


        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                setTimeout(() => this.selectedOpen = true, 10)
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                setTimeout(open, 10)
            }
            else {
                open()
            }

            nativeEvent.stopPropagation()
        },


        updateRange({ start, end }) {
            this.start = start
            this.end = end
            //this.events = events
        },


        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },


        formatDate(a, withTime) {
            return withTime
                ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
                : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
        },



        showIntervalLabel(interval) {
            return interval.minute === 0
        },
        ///////////////////////////////////////////////////////////

    },
}
</script>
